import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export function RequiredSymbol() {
  const { t } = useSonTranslation('FormRequiredSymbol');

  return (
    // can be aria hidden, because irrelevant for screen readers
    <span className="form-required-symbol" title={t('required')} aria-hidden="true">
      {' '}
      *
    </span>
  );
}
